import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Navbar2 from "../components/Navbar2";
import { useMediaQuery } from "react-responsive";
import Navbar from "../components/Navbar";
import NavbarMob from "../components/NavbarMob";
import { useNavigate } from "react-router-dom";
import Navbar2Mob from "../components/Navbar2Mob";
import Select from "react-select";

function EnableJobPost() {
    const [jobPosts, setJobPosts] = useState([]);
    const [staffData, setStaffData] = useState(null);
    const staffId = sessionStorage.getItem("employeeId");
    const [loading, setLoading] = useState(true); // State to handle loading
    const [error, setError] = useState(null); // State to handle errors

    const navigate = useNavigate();

    const [searchQuery, setSearchQuery] = useState({
        employee_id: "",
        job: "",
        location: "",
        job_id: "",
        whatsapp_number: "",
        gender_type: "",
        shopName: "",
        job_description: "",
    });

    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    // Navigate to details page with job_id passed as state
    const detailsforstaff = (jobId) => {
        // console.log("passing Job ID: ", jobId);
        navigate("/detailsforstaff", { state: { jobId } }); // Pass job_id as state
    };

    // Fetch data from the API
    useEffect(() => {
        const loadData = async () => {
            try {
                const jobPostsPromise = fetch(`${apiBaseUrl}/getjobposts`).then((res) => res.json());

                const staffDataPromise = staffId
                    ? fetch(`${apiBaseUrl}/fetchstaff?staffId=${encodeURIComponent(staffId)}`).then(res => {
                        if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
                        return res.json();
                    })
                    : Promise.resolve(null);

                const [jobPostsData, staffDataResult] = await Promise.all([jobPostsPromise, staffDataPromise]);

                setJobPosts(jobPostsData);
                if (staffDataResult) {
                    setStaffData(staffDataResult);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                setError("Unable to fetch data.");
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, [apiBaseUrl, staffId]);

    // console.log("jobpost:",jobPosts)
    const cleanedSearchTerm = searchQuery.whatsapp_number
        .replace(/^\+91|\+91|\+/g, "") // Remove +91 at start, +91 anywhere, or lone +
        .replace(/\s/g, "") // Remove spaces
        .replace(/\D/g, "");

    // Filter job posts based on the search query
    const filteredJobPosts = jobPosts.filter((job) => {
        const displayedJobId = job.manualJobID && job.manualJobID !== "0" ? job.manualJobID : job.job_id;
        const cleanedMobile = job.whatsapp_number
            ? job.whatsapp_number
                .toString()
                .replace(/^\+91|\+91|\+/g, "")
                .replace(/\s/g, "")
                .replace(/\D/g, "")
            : "";

        const mobileMatch = cleanedSearchTerm === "" || cleanedMobile.includes(cleanedSearchTerm);
        return (
            job.employee_id.toString().includes(searchQuery.employee_id || "") &&
            job.job.toLowerCase().includes((searchQuery.job || "").toLowerCase()) &&
            (job.location?.toLowerCase().includes((searchQuery.location || "").toLowerCase()) ||
                job.address?.toLowerCase().includes((searchQuery.location || "").toLowerCase())) &&
            displayedJobId.toString().includes(searchQuery.job_id || "") &&
            mobileMatch &&
            (searchQuery.gender_type === "" || job.gender_type === searchQuery.gender_type) &&
            (!searchQuery.shopName || job.shopName?.toLowerCase().includes(searchQuery.shopName.toLowerCase())) &&
            (!searchQuery.job_description ||
                job.job_description?.toLowerCase().includes(searchQuery.job_description.toLowerCase())) &&
            (!searchQuery.company_type || job.company_type?.toLowerCase().includes(searchQuery.company_type.toLowerCase()))
        );
    });

    // Handle search input change
    const handleSearchChange = (e) => {
        const { name, value } = e.target;
        setSearchQuery((prevQuery) => ({
            ...prevQuery,
            [name]: value,
        }));
    };

    // Toggle enable status
    const handleToggle = async (jobId, currentEnableStatus) => {
        const newEnableStatus = currentEnableStatus === "off" ? "on" : "off";

        // Update the UI optimistically
        setJobPosts((prevPosts) =>
            prevPosts.map((job) => (job.job_id === jobId ? { ...job, enable: newEnableStatus } : job))
        );

        try {
            // Update the enable status
            const enableResponse = await fetch(`${apiBaseUrl}/updateJobEnable`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    jobId,
                    enable: newEnableStatus,
                }),
            });

            const enableResult = await enableResponse.json();
            if (!enableResult.success) {
                console.error("Failed to update status:", enableResult.message);
                return; // Stop further execution if the status update fails
            }

            // If the status is changed to "on," update the created_at field
            if (newEnableStatus === "on") {
                const createdAtResponse = await fetch(`${apiBaseUrl}/jobpost/updateCreatedAt`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ jobId }),
                });

                const createdAtResult = await createdAtResponse.json();
                if (createdAtResult.success) {
                    // console.log("Created date updated successfully.");
                } else {
                    console.error("Failed to update created date:", createdAtResult.message);
                }
            }
        } catch (error) {
            console.error("Error updating job enable status or created date:", error);
        }
    };



    return (
        <div className="min-h-screen flex flex-col">
            {isMobile ? <NavbarMob /> : <Navbar />}
            <div className="md:flex hidden">
                <Navbar2 />
            </div>
            <div className="md:hidden flex flex-col">
                <Navbar2Mob />
            </div>

            <div className="flex flex-col gap-8 px-3 mt-8 pb-12 sm:px-6 lg:px-8">
                <h1 className="text-xl font-bold text-center text-gray-800">Job Post Requests</h1>

                {/* Search Inputs */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6  gap-4  max-w-7xl mx-auto px-4">
                    <input
                        type="text"
                        name="employee_id"
                        placeholder="Search by Employee ID"
                        value={searchQuery.employee_id}
                        onChange={handleSearchChange}
                        className="border border-gray-400 p-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                    />
                    <input
                        type="text"
                        name="job"
                        placeholder="Search by Job"
                        value={searchQuery.job}
                        onChange={handleSearchChange}
                        className="border border-gray-400 p-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                    />
                    <input
                        type="text"
                        name="location"
                        placeholder="Search by Location"
                        value={searchQuery.location}
                        onChange={handleSearchChange}
                        className="border border-gray-400 p-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                    />
                    <input
                        type="text"
                        name="job_id"
                        placeholder="Search by Job ID"
                        value={searchQuery.job_id}
                        onChange={handleSearchChange}
                        className="border border-gray-400 p-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                    />
                    <input
                        type="text"
                        name="whatsapp_number"
                        placeholder="Search by Number"
                        value={searchQuery.whatsapp_number}
                        onChange={handleSearchChange}
                        className="border border-gray-400 p-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                    />
                    <input
                        type="text"
                        name="job_description"
                        placeholder="Search by Description"
                        value={searchQuery.job_description}
                        onChange={handleSearchChange}
                        className="border border-gray-400 p-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                    />
                    <input
                        type="text"
                        name="company_type"
                        placeholder="Search by Category"
                        value={searchQuery.company_type}
                        onChange={handleSearchChange}
                        className="border border-gray-400 p-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                    />
                    <div className="w-full">
                        <Select
                            options={[
                                { value: "", label: "All Genders" },
                                { value: "MALE", label: "Male" },
                                { value: "FEMALE", label: "Female" },
                                { value: "MALE/FEMALE", label: "Male/Female" },
                            ]}
                            value={{
                                value: searchQuery.gender_type,
                                label:
                                    searchQuery.gender_type === "MALE"
                                        ? "Male"
                                        : searchQuery.gender_type === "FEMALE"
                                            ? "Female"
                                            : searchQuery.gender_type === "MALE/FEMALE"
                                                ? "Male/Female"
                                                : "All Genders",
                            }}
                            onChange={(selectedOption) =>
                                setSearchQuery((prev) => ({
                                    ...prev,
                                    gender_type: selectedOption.value,
                                }))
                            }
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    border: "1px solid #9CA3AF",
                                    borderRadius: "0.5rem",
                                    padding: "0.75rem",
                                    minHeight: "48px",
                                    boxShadow: "none",
                                    "&:hover": { borderColor: "#2563eb" },
                                }),
                            }}
                            className="w-full"
                            placeholder="Filter by Gender"
                        />
                    </div>
                    <input
                        type="text"
                        name="shopName"
                        placeholder="Search by Shop Name"
                        value={searchQuery.shopName}
                        onChange={handleSearchChange}
                        className="border border-gray-400 p-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full"
                    />
                </div>
                <div className="flex justify-between items-center text-sm text-gray-600 px-1">
                    <p>
                        Showing <strong>{filteredJobPosts.length}</strong> of <strong>{jobPosts.length}</strong> job posts
                    </p>
                    <p>
                        <strong>{filteredJobPosts.filter((job) => job.enable === "on").length}</strong> active job
                        posts out of <strong>{filteredJobPosts.length}</strong>
                    </p>

                    {Object.values(searchQuery).some((val) => val !== "") && (
                        <button
                            onClick={() => {
                                setSearchQuery({
                                    employee_id: "",
                                    job: "",
                                    location: "",
                                    job_id: "",
                                    whatsapp_number: "",
                                    gender_type: "",
                                    shopName: "",
                                    job_description: "",
                                    company_type: "", // ← don't forget this one
                                });
                            }}
                            className="text-red-600 hover:text-red-800 underline font-medium"
                        >
                            Clear all filters
                        </button>
                    )}
                </div>

                {/* Table displaying job posts */}
                {loading ? (
                    <div className="flex justify-center items-center h-64">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                    </div>
                ) : (
                    <div className="overflow-auto max-h-[60vh]">
                        <table className="table-auto w-full border-collapse bg-gray-50">
                            <thead className="bg-blue-600 text-white sticky top-0 z-10 shadow-md">
                                <tr className="bg-blue-600 text-white">
                                    <th className="border p-2">Employee ID</th>
                                    <th className="border p-2">Job ID</th>
                                    <th className="border p-2">Job</th>
                                    <th className="border p-2">Description</th>
                                    <th className="border p-2">Category</th>
                                    <th className="border p-2">Location</th>
                                    <th className="border p-2">Gender</th>
                                    <th className="border p-2">Number</th>
                                    <th className="border p-2">Shop Name</th>
                                    <th className="border p-2">Address</th>
                                    <th className="border p-2">Activated Date</th>
                                    <th className="border p-2"></th>
                                    {staffData && staffData.power === "on" && <th className="border p-2">Accept</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {filteredJobPosts.map((job) => (
                                    <tr key={job.job_id} className="hover:bg-gray-100 transition duration-200">
                                        <td className="border p-2">{job.employee_id}</td>
                                        <td className="border p-2">
                                            {job.manualJobID && job.manualJobID !== "0" ? job.manualJobID : job.job_id}
                                        </td>
                                        <td className="border p-2">{job.job}</td>
                                        <td className="border p-2">{job.job_description}</td>
                                        <td className="border p-2">{job.company_type}</td>
                                        <td className="border p-2">{job.location}</td>
                                        <td className="border p-2">{job.gender_type || "Not specified"}</td>
                                        <td className="border p-2">{job.whatsapp_number}</td>
                                        <td className="border p-2">{job.shopName || "N/A"}</td>
                                        <td className="border p-2 break-words whitespace-normal max-w-[200px]">
                                            {job.address || "N/A"}
                                        </td>
                                        <td className="border p-2">{new Date(job.created_at).toLocaleDateString("en-GB")}</td>
                                        <td className="border p-2">
                                            <button
                                                className={"text-[red] hover:text-[black] px-4 py-2 rounded-lg underline"}
                                                onClick={() =>
                                                    detailsforstaff(
                                                        job.manualJobID && job.manualJobID !== "0"
                                                            ? job.manualJobID
                                                            : job.job_id
                                                    )
                                                }
                                            >
                                                View Job
                                            </button>
                                        </td>
                                        {staffData && staffData.power === "on" && (
                                            <td className="border p-2 text-center">
                                                <button
                                                    className={`${job.enable === "on" ? "bg-green-500" : "bg-red-500"
                                                        } text-white px-4 py-2 rounded-lg`}
                                                    onClick={() => handleToggle(job.job_id, job.enable)}
                                                >
                                                    {job.enable === "on" ? "On" : "Off"}
                                                </button>
                                            </td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            <div className="mt-12">
                <Footer />
            </div>
        </div>
    );
}

export default EnableJobPost;
